import React from 'react'
import { Answer as AnswerType } from '@/types/admin'
import Pagination from '@/components/Shared/Pagination'
import Answer from '@/components/Admin/Answer'

interface AnswersTabProps {
  answers: AnswerType[]
  pagination: {
    current_page: number
    total_pages: number
    total_count: number
    per_page: number
  }
}

const AnswersTab: React.FC<AnswersTabProps> = ({ answers, pagination }) => {
  return (
    <div>
      {answers.length === 0 ? (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-8 text-center">
          <p className="text-gray-500">No hay respuestas aún.</p>
        </div>
      ) : (
        <div className="space-y-6">
          {answers.map((answer, index) => {
            const answerNumber = (pagination.current_page - 1) * pagination.per_page + index + 1
            return <Answer key={answer.id} answer={answer} answerNumber={answerNumber} />
          })}
          <Pagination
            currentPage={pagination.current_page}
            totalPages={pagination.total_pages}
            totalCount={pagination.total_count}
          />
        </div>
      )}
    </div>
  )
}

export default AnswersTab
